import { i18n } from '../config/i18n/i18n';

export default defineNuxtPlugin(({ vueApp }) => { vueApp.use(i18n); });
